import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 考试场次.
 *
 * TODO (user 后续):
 *   - ExamSessionPaper M2M 中间表 (含权重) 需要专门挂卷 UI
 *   - 准入设备 / 摄像头要求 / 监考策略 JSON 配置可视化
 */
export const examSessionsConfig: CrudConfig = {
  resource: 'exam-sessions',
  title: '考试场次',
  rowKey: 'id',
  searchFields: ['status', 'session_type', 'industry'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'name', label: '场次名称', type: 'text', required: true, ellipsis: true },
    {
      name: 'session_type',
      label: '场次类型',
      type: 'select',
      required: true,
      width: 110,
      options: [
        { label: '正式考试', value: 'FORMAL', color: 'red' },
        { label: '模拟考试', value: 'MOCK', color: 'blue' },
      ],
    },
    {
      name: 'time_mode',
      label: '时间模式',
      type: 'select',
      width: 120,
      options: [
        { label: '固定时间', value: 'FIXED_TIME', color: 'blue' },
        { label: '自定步调', value: 'SELF_PACED', color: 'cyan' },
      ],
    },
    {
      name: 'scoring_mode',
      label: '评分模式',
      type: 'select',
      width: 130,
      options: [
        { label: '整卷评分', value: 'FULL_PAPER', color: 'blue' },
        { label: '单题评分', value: 'SINGLE_QUESTION', color: 'cyan' },
      ],
    },
    {
      name: 'result_publish_mode',
      label: '出分方式',
      type: 'select',
      width: 120,
      options: [
        { label: '自动', value: 'AUTO', color: 'green' },
        { label: '手动', value: 'MANUAL', color: 'orange' },
      ],
    },
    { name: 'industry', label: '行业 ID', type: 'number', width: 100 },
    { name: 'start_time', label: '开始时间', type: 'datetime', width: 180, hideInSearch: true },
    { name: 'end_time', label: '结束时间', type: 'datetime', width: 180, hideInSearch: true, hideInTable: true },
    { name: 'max_retry_count', label: '最大重试', type: 'number', width: 100, hideInSearch: true, hideInTable: true },
    { name: 'max_scorer_count', label: '最大评分员', type: 'number', width: 110, hideInSearch: true, hideInTable: true },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 110,
      options: [
        { label: '草稿', value: 'DRAFT', status: 'Default' },
        { label: '已排期', value: 'SCHEDULED', color: 'blue' },
        { label: '激活', value: 'ACTIVE', status: 'Processing', color: 'cyan' },
        { label: '进行中', value: 'ONGOING', status: 'Processing', color: 'blue' },
        { label: '已关闭', value: 'CLOSED', color: 'orange' },
        { label: '已完成', value: 'COMPLETED', status: 'Success', color: 'green' },
        { label: '已取消', value: 'CANCELLED', status: 'Error', color: 'red' },
      ],
    },
  ],
};
